import { parseVideoDisplayRotationDegrees } from '@shared/videoDisplayRotation';
import type { VideoRotationDegrees } from './walkthroughVideoRotation';
import { normalizeVideoRotationDegrees } from './walkthroughVideoRotation';

const SAMPLE_BYTES = 2 * 1024 * 1024;

async function readFileSlice(file: File, start: number, endExclusive: number): Promise<Uint8Array> {
  const buffer = await file.slice(start, endExclusive).arrayBuffer();
  return new Uint8Array(buffer);
}

/** Read QuickTime/MP4 display rotation from a local video file. */
export async function detectVideoRotationFromFile(file: File): Promise<VideoRotationDegrees> {
  if (file.size <= SAMPLE_BYTES * 2) {
    const bytes = new Uint8Array(await file.arrayBuffer());
    return normalizeVideoRotationDegrees(parseVideoDisplayRotationDegrees(bytes));
  }

  const head = await readFileSlice(file, 0, SAMPLE_BYTES);
  const tail = await readFileSlice(file, file.size - SAMPLE_BYTES, file.size);
  const combined = new Uint8Array(head.length + tail.length);
  combined.set(head, 0);
  combined.set(tail, head.length);
  return normalizeVideoRotationDegrees(parseVideoDisplayRotationDegrees(combined));
}
